// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + "cdaf31bbd8b63fd793bb" + ".chunk.js";
};